import { render, staticRenderFns } from "./ReleaseSummary.vue?vue&type=template&id=ae3fcb52&scoped=true"
import script from "./ReleaseSummary.vue?vue&type=script&lang=js"
export * from "./ReleaseSummary.vue?vue&type=script&lang=js"
import style0 from "./ReleaseSummary.vue?vue&type=style&index=0&id=ae3fcb52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3fcb52",
  null
  
)

export default component.exports